import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  stakeholderTypeSelect: {
    // reset '.section .field' marginTop: 16px
    marginTop: [0, '!important']
  },
  rowWith3Items: {
    display: 'flex',
    justifyContent: 'space-between',
    columnGap: 30
  },
  fieldInRow: {
    maxWidth: 90
  },
  col: {
    paddingRight: 10
  },
  rowWith2Items: {
    display: 'flex',
    justifyContent: 'space-between',
    '& > $col': {
      width: '50%'
    }
  }
})

export default useStyles
